 export const professionList = {
  professionMarketing: 'Координатор маркетингу',
  professionWebDesigner: 'Веб-дизайнер',
  professionSales: 'Президент з продажів',
  professionCoordinator: 'Координатор маркетингу',
};

export const pageTitle = 'Наша команда';
